<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-joylearning_achPolicySetBase}">
      <el-form label-width="auto"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="queryDataList()">
        <el-row class="margb10">
          <!-- 年度 -->
          <el-col :span="5">
            <el-form-item :label="$t('policy.year')">
                <el-date-picker v-model="dataForm.curYear"
                                :editable="false"
                                type="year"
                                value-format="yyyy"
                                :start-placeholder="$t('policy.year')"
                                :clearable="false"
                                @change="queryDataList()"
                                style="width: 90%">
                </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 品牌 -->
          <el-col :span="5" v-if="false">
            <el-form-item :label="$t('policy.brand')">
              <el-select v-model="dataForm.certBrand"
                         :placeholder="$t('policy.select')"
                         clearable>
                <el-option v-for="(item,index) in certBrandArrs"
                           :key="index"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 培训类型 -->
          <el-col :span="5" v-if="false">
            <el-form-item :label="$t('policy.trainCategory')">
              <el-select v-model="dataForm.trainCategory"
                         :placeholder="$t('policy.select')"
                         clearable>
                <el-option v-for="(item,index) in trainTypeArrs"
                           :key="index"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 岗位分类 -->
          <el-col :span="5" v-if="false">
            <el-form-item :label="$t('policy.jobCategory')">
              <el-select v-model="dataForm.jobCategory"
                         :placeholder="$t('policy.select')"
                         clearable>
                <el-option v-for="(item,index) in jobTypeArrs"
                           :key="index"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 查询 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="queryDataList">{{$t('query')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>

      <div class="search1">
      </div>

      <div class="search">
        <!-- 导出模板 -->
        <el-button type="primary"
                   @click="exportTemplate()">{{ $t('policy.downloadtemplate') }}</el-button>
        <!-- 开始上传" -->
        <el-button type="primary" @click="uploadData"
                   >{{ $t('policy.startUpload') }}</el-button>
                   <div style="width: 90px;
        height: 34px;
        line-height: 34px;
        margin-left: 10px;">
                规则说明
                <span>
                  <el-tooltip placement="bottom" effect="light">
                      <div slot="content">
                        针对每年的政策设置，请按照以下顺序进行维护：<br/>
                      第一步，请维护【政策龄基础设置】；<br/>
                      第二步，请维护【通用考核及目标设置】，设置考核项目及目标；<br/>
                      第三步，请维护【考核经销商设置】，设置需考核的经销商列表；<br/>
                      第四步，如有特殊考核设置，请维护【特殊目标设置】；<br/>
                      关键基础岗在岗人数考核类型请维护【在岗人数考核设置】。<br/>
                      </div>
                    <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                      src="@/assets/img/course/icon-question-fill.png" alt="" />
                  </el-tooltip>
                </span>
            </div>
      </div>
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                style="width: 100%;">
        <!--品牌-->
        <el-table-column prop="brandCode"
                         header-align="center"
                         align="center"
                         min-width="10%"
                         :label="$t('policy.brand')">
        </el-table-column>
        <!--考核类型代码-->
        <el-table-column prop="trainingCategory"
                         :label="$t('policy.trainCategoryCode')"
                         header-align="center"
                         align="center"
                         min-width="10%"></el-table-column>
        <!--考核类型-->
        <el-table-column prop="trainingCategoryName"
                         :label="$t('policy.trainCategory')"
                         header-align="center"
                         align="center"
                         min-width="10%"></el-table-column>
        <!--项目分类代码-->
        <el-table-column prop="jobCategory"
                         :label="$t('policy.jobCategoryCode')"
                         header-align="center"
                         align="center"
                         min-width="10%"></el-table-column>
        <!--项目分类-->
        <el-table-column prop="jobCategoryName"
                         :label="$t('policy.jobCategory')"
                         header-align="center"
                         align="center"
                         min-width="10%"></el-table-column>
        <!--主职职位-->
        <el-table-column prop="jobCodes"
                         :label="$t('policy.position')"
                         header-align="center"
                         align="center"
                         min-width="25%"></el-table-column>
        <!--兼职职位-->
        <el-table-column prop="partTimeJobCodes"
                         :label="$t('policy.partTimePosition')"
                         header-align="center"
                         align="center"
                         min-width="25%"></el-table-column>
      </el-table>
    </div>
    <!--开始上传-->
    <cert-import ref="certImport" v-bind:visible="importExcelVisible"
                  v-bind:url="uploadURL"
                  :curYear="this.dataForm.curYear"
                  v-on:closeDialogImport="closeDialogImport"></cert-import>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import ToggleDiv from '@/components/toggle-div'
import CertImport from '../certImport'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  data () {
    let _this = this
    return {
      mixinViewModuleOptions: {
        //请求地址暂未定
        getDataListURL: '/learning/achievePolicySetting/infoList',
        getDataListIsPage: false,
        downloadURL: '/learning/achievePolicySetting/downloadBase'
      },
      dataList: [],
      // 品牌
      certBrandArrs: _this.enums['acheBaseBrand'],
      // 培训类型
      trainTypeArrs: _this.enums['acheBaseTrain'],
      // 主要职位类型
      jobTypeArrs: _this.enums['acheBaseJob'],
      // 开始上传
      importExcelVisible: false,
      uploadURL: '/learning/achievePolicySetting/import',
      dataForm: {
        curYear: ''+new Date().getFullYear(),
        certBrand: '',
        trainCategory: '',
        jobCategory: ''
      },
      dataFormHold: {
        certBrandArrs: [],
        trainTypeArrs: []
      },
      // 等待转圈
      dataListLoading: false
    }
  },
  components: {
    ToggleDiv,
    CertImport
  },
  methods: {
    // 查询
    queryDataList () {
      console.log('main queryDataList start')
      this.getDataList()
    },
    exportTemplate () {
      this.$request.downloadLearning(this.mixinViewModuleOptions.downloadURL, this.$t('policy.exportBase'),
        {
          curYear: this.dataForm.curYear
        }
      )
    },
    // 开始上传
    uploadData () {
      console.log('开始上传'),
      this.importExcelVisible = true
      this.$nextTick(() => {
        this.$refs.certImport.init()
      })
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        curYear: ''+new Date().getFullYear(),
        certBrand: '',
        trainCategory: '',
        jobCategory: ''
      }
      this.dataFormHold = {
        certBrandArrs: [],
        trainTypeArrs: []
      }
      this.queryDataList()
    },
    getCurrentYear () {
      return new Date().getFullYear();
    },
    // 关闭导入弹框
    closeDialogImport () {
      this.importExcelVisible = false
      this.queryDataList()
    }
  }
}
</script>
<style scoped>
@import "../../../../css/pkg-styles.css";
.el-date-editor.el-input {
  width: 150px;
}
.search1 {
  height: 10px;
}
.search {
  height: 34px;
  display: flex;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
